<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          class="mr-4 ml-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewItem"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change
          "
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="params?.context?.parentComponent?.disablePermissions?.change"
          class="ml-2 mr-1"
          :color="is_customer_active === 'No' ? 'grey' : 'primary'"
          :style="{ opacity: is_customer_active === 'No' ? 0.5 : 1 }"
          v-on="on"
          v-bind="attrs"
          @click="changeStatus"
        >
          mdi-toggle-switch
        </v-icon>
      </template>
      <span>Active/ De-active customer</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    is_customer_active() {
      return this.params?.data?.is_active || "No";
    },
  },
  methods: {
    editItem() {
      this.params.context.parentComponent.editTransporter(this.params.data.id);
    },
    viewItem() {
      this.params.context.parentComponent.getTransporterDetails(
        this.params.data
      );
    },
    changeStatus() {
      if (this.params) {
        this.params.context.parentComponent.confirmation(
          this.params.data.id,
          this.params.data.is_active
        );
      }
    },
  },
};
</script>

<style></style>
